import {ContainerSVG} from "components/waste-icons/svgs/ContainerSVG";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconFillingColoured} from "site-apps/assets/AssetColorsIcons";

const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";

const STATUS_LABELS = {
    P: "Pendiente",
    I: "En progreso",
    D: "Completado",
    S: "Saltado",
};

const RouteIslandCard = ({asset, wasteType}) => {
    const {t: tc} = useTranslation("choices");
    return (
        <div className="row card-asset-basic">
            <div className="col asset-svg">
                {asset.is_island ? (
                    <img src={`${urlStatic}/images/icons/waypoints/1-island.svg`} height={38} alt="Isla" />
                ) : (
                    <ContainerSVG type={wasteType} />
                )}
                <div className="row overflow-x-hidden">
                    <small className="text-muted fs-08">{asset.is_island ? "Isla" : tc("wastes." + wasteType)}</small>
                </div>
                <div className="row text-center">
                    <span className="h2 text-secondary">{asset.order}</span>
                </div>
            </div>
            <div className="col">
                <div className="fw-semibold">{asset.uid}</div>
                <div className="small text-muted">{asset.full_address}</div>
                {asset.is_island && asset.uuid_info?.length > 0 && (
                    <div className="mt-1 small text-muted">
                        {asset.uuid_info.length} contenedor(es)
                    </div>
                )}
                {!asset.is_island && asset.uuid_info?.length > 0 && (
                    <div className="mt-1">
                        {asset.uuid_info.map((item) => (
                            <div key={item.uuid} className="mb-1 pb-1">
                                <div className="small">{item.model}</div>
                                <div className="d-flex align-items-center gap-2">
                                    <IconFillingColoured value={item.filling} />
                                    <span className="small text-muted">{item.uuid}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {asset.status && (
                    <div className="mt-1">
                        <div className="small">{STATUS_LABELS[asset.status] || asset.status}</div>
                    </div>
                )}
            </div>
            <div className="col icons">
                {asset.has_device ? <FontAwesomeIcon icon="wifi" title="Tiene sensor" /> : <></>}
                {asset.has_route ? <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" /> : <></>}
                {asset.has_alert ? <FontAwesomeIcon icon="triangle-exclamation" title="Tiene alerta" /> : <></>}
            </div>
        </div>
    );
};
export default RouteIslandCard;
